import { useEffect } from 'react';

import { websocketActions } from 'middleware/websocket/actions/websocket';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

/**
 * Subscribes to the organization_presence WebSocket channel.
 *
 * Uses reference-counted subscriptions (via middleware). Multiple components
 * can subscribe, and the channel remains active until all unsubscribe.
 */
export const useOrganizationPresenceSubscription = (): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(
      websocketActions.request({
        type: 'connection:subscribe',
        params: { type: 'organization_presence' },
      }),
    );

    return () => {
      dispatch(
        websocketActions.request({
          type: 'connection:unsubscribe',
          params: { type: 'organization_presence' },
        }),
      );
    };
  }, [dispatch]);
};
